import { render } from "./MdMenuItem.vue?vue&type=template&id=bdfe7364"
import script from "./MdMenuItem.vue?vue&type=script&lang=js"
export * from "./MdMenuItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__